module.exports = __webpack_public_path__ + "static/media/chauffeur.46748376.svg";